/** Pure reducer for AuthSession state. No side effects. */

import type { AuthSessionAction, AuthSessionState } from './types';
import { INITIAL_STATE } from './types';

export { INITIAL_STATE };

/**
 * Pure reducer for `AuthSessionState`.
 *
 * Every state transition is explicit and exhaustive:
 * - `AUTH_COMPLETE` — a sign-in or social auth resolved successfully; user is set and session is marked loaded.
 * - `USER_UPDATED` — profile data changed in-place (e.g. after `setUser`); loaded flag is untouched.
 * - `SESSION_LOADED` — bootstrap finished; user may be `null` if no persisted session was found.
 * - `SESSION_CLEARED` — sign-out, account deletion, or an unrecoverable refresh error; user is wiped.
 *
 * Never call this directly — `AuthSession.dispatch()` is the only entry point.
 */
export function authSessionReducer(
  state: AuthSessionState,
  action: AuthSessionAction,
): AuthSessionState {
  switch (action.type) {
    case 'AUTH_COMPLETE':
      return { ...state, user: action.user, loaded: true };

    case 'USER_UPDATED':
      return { ...state, user: action.user };

    case 'SESSION_LOADED':
      return { ...state, user: action.user, loaded: true };

    case 'SESSION_CLEARED':
      return { ...state, user: null, loaded: true };

    default:
      return state;
  }
}
